import React from 'react';

import { cn } from '@/lib/utils';

import { describeSectionLastUpdated } from './sectionLastUpdated';

type SectionLastUpdatedLabelProps = {
  section: Parameters<typeof describeSectionLastUpdated>[0];
  className?: string;
};

/** Shows when a single report section last changed, and who changed it. */
export const SectionLastUpdatedLabel: React.FC<
  SectionLastUpdatedLabelProps
> = ({ section, className }) => {
  const lastUpdated = describeSectionLastUpdated(section);
  if (!lastUpdated) return null;

  return (
    <small
      className={cn('tw:text-muted-foreground', className)}
      data-testid="reports-section-last-updated"
      title={lastUpdated.formattedTime}
    >
      {lastUpdated.label}
    </small>
  );
};

export default SectionLastUpdatedLabel;
